// src/stores/menu.js
import { defineStore } from 'pinia';
import { watch } from 'vue';

export const useMenuStore = defineStore('menu', {
    state: () => ({
        menus: []
    }),
    actions: {
        setMenuItems(items) {
            this.menus = items;
        },
        clearMenu() {
            this.menus = [];
        },
        defaultMenu() {
            this.menus = [
                {
                    label: '',
                    items: [
                        {
                            label: '系統管理',
                            icon: 'pi pi-fw pi-bookmark',
                            id: 'system',
                            items: [
                                { id: 'system-1', label: '用戶管理', icon: 'pi pi-fw pi-bookmark', to: { name: 'User' } },
                                { id: 'system-2', label: '會員清單', icon: 'pi pi-fw pi-users', to: { name: 'memberlist' } },
                            ]
                        },
                        {
                            label: '社團管理',
                            icon: 'pi pi-fw pi-bookmark',
                            id: 'clubs',
                            items: [
                                { id: 'clubs-list', label: '社團列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'clublist' } },
                                { id: 'clubs-category', label: '社團分類管理', icon: 'pi pi-fw pi-bookmark', to: { name: 'clubcategory' } },
                                { id: 'clubs-location', label: '社團據點管理', icon: 'pi pi-fw pi-bookmark', to: { name: 'clublocation' } },
                            ]
                        },
                        {
                            label: '活動管理',
                            icon: 'pi pi-fw pi-bookmark',
                            id: 'events',
                            items: [
                                { id: 'events-lists', label: '活動列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'eventlist' } },
                                { id: 'events-category', label: '活動分類管理', icon: 'pi pi-fw pi-bookmark', to: { name: 'eventcategory' } },
                            ]
                        },
                        {
                            label: '資訊管理',
                            icon: 'pi pi-fw pi-bookmark',
                            id: 'information',
                            items: [
                                { id: 'popular-list', label: '熱門活動列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'popularlist' } },
                                { id: 'news-list', label: '最新消息列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'newslist' } },
                                { id: 'related-list', label: '相關資源列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'relatedlist' } },
                                { id: 'weeklymenu-list', label: '每週菜單列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'weeklymenu' } },
                                { id: 'benefitspolicy-list', label: '福利辦法列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'benefitspolicy' } },
                                { id: 'organizerinfo-list', label: '主辦資訊列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'organizerinfo' } }
                            ]
                        },
                        {
                            label: '商店管理',
                            icon: 'pi pi-fw pi-bookmark',
                            id: 'storeManagement',
                            items: [
                                { id: 'storelist', label: '特約商店列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'storelist' } },
                                { id: 'promotionlist', label: '優惠資訊列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'promotionlist' } },
                                { id: 'birthdaycouponlist', label: '生日券管理', icon: 'pi pi-fw pi-gift', to: { name: 'birthdaycouponlist' } },
                                { id: 'storecategory', label: '商店類別列表', icon: 'pi pi-fw pi-bookmark', to: { name: 'storecategory' } }
                            ]
                        },
                        {
                            label: '報表',
                            icon: 'pi pi-fw pi-chart-bar',
                            id: 'report',
                            items: [
                                { id: 'activityoverview', label: '活動總覽', icon: 'pi pi-fw pi-calendar', to: { name: 'activityoverview' } },
                                { id: 'checkinanalysis', label: '活動報到分析', icon: 'pi pi-fw pi-check-square', to: { name: 'checkinanalysis' } },
                                { id: 'clubactivity', label: '社團活動數', icon: 'pi pi-fw pi-list', to: { name: 'clubactivity' } },
                                { id: 'registrationreport', label: '註冊人數', icon: 'pi pi-fw pi-user-plus', to: { name: 'registrationreport' } },
                                { id: 'birthdaycouponreport', label: '生日券核銷報表', icon: 'pi pi-fw pi-chart-bar', to: { name: 'birthdaycouponreport' } },
                                { id: 'promotioncouponreport', label: '優惠資訊核銷報表', icon: 'pi pi-fw pi-chart-bar', to: { name: 'promotioncouponreport' } }
                            ]
                        }
                    ]
                },

            ]
        },
        guestMenu() {
            this.menus = [
                {
                    label: '',
                    items: [
                        {
                            label: '商家管理',
                            icon: 'pi pi-fw pi-bookmark',
                            id: 'transaction',
                            items: [
                                { id: 'store-1', label: '交易管理', icon: 'pi pi-fw pi-bookmark', to: { name: 'Storetransaction' } },
                            ]
                        },
                    ]
                },

            ]
        },

    }
});

